export const isValidpostalCode = (value: any) =>
    /^[0-9]{4}[a-z|A-Z]{2}$|^[0-9]{4}[ ]?[a-z|A-Z]{2}$/i.test(value);
export const isNumber = (value: any) => !isNaN(Number(value));
export const isValidDate = (value: any) =>
    /^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}$/.test(value);
export const isValidPhoneNumber = (value: any) => value.length >= 10 && value.length <= 100;
export const isValidEmail = (value: any) => /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(value);
